
import objectPath from 'object-path'

const getters = {
  getDictionary: (state, allGetters, rootState) => target => objectPath.get(rootState, target),
}

export default getters